import React from "react";
import { optionMasterService } from "app/_services/OptionMasterService/optionMasterService";
import toastr from "toastr";
import { Link } from "react-router-dom";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiCamera } from "react-icons/fi";
import DateTime from "react-datetime";
import { FiEye } from "react-icons/fi";
import { UserService } from "app/_services/UserService/UserService";
import { DepartmentService } from "app/_services/UserManagement/DepartmentService";
import { RoleService } from "app/_services/RoleService/RoleService";
import { formatDate, parseDate } from "react-day-picker/moment";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { CommmonService } from "app/_services/CommonService/CommonService";
import Loader from "app/views/custom/components/Loader/Loader";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import ReactCrop from "react-image-crop";
import moment from "moment";
import CropImageModal from "app/Components/CropImageModal";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";

class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: {},
      firstName: "",
      lastName: "",
      email: "",
      contactNumber: "",
      roleId: "",
      comapnyId: "",
      departmentId: "",
      displayName: "",
      employeeId: "",
      functionName: "",
      siteName: "",
      supervisorName: "",
      joiningDate: "",
      landlineNumber: "",
      emergencyContact: "",
      officeAddress: "",
      siteAddress: "",
      remarks: "",
      dob: null,
      selectedFile: null,

      roleArr: [],
      companyArr: [],
      isLoading: false,

      showImage: false,
      cropImage: false,
      showSignatureImage: false,
      cropSignatureImage: false,
      src: "",
      signatureSrc: "",
      crop: { aspect: 1 / 1 },
      signatureCrop: { aspect: 2 / 1 },
      img: null,
      signatureImg: null,
      approveStatus: "",
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    this.loggedUser();
    this.getRolesList();
    this.getCompanyList();
    this.getDepartmentList();
  }

  async loggedUser() {
    let response = await UserService.loggedUser();
    if (response && response.status) {
      let userData = response.data;
      this.setState({
        userData: response.data,
        firstName: userData.firstName,
        lastName: userData.lastName,
        email: userData.email,
        contactNumber: userData.contactNumber,
        roleId: userData.roleId,
        comapnyId: userData.comapnyId,
        classification: userData.classification,
        departmentId: userData.departmentId,
        displayName: userData.displayName,
        employeeId: userData.employeeId,
        functionName: userData.functionName,
        siteName: userData.siteName,
        supervisorName: userData.supervisorName,
        joiningDate: userData.joiningDate,
        landlineNumber: userData.landlineNumber,
        emergencyContact: userData.emergencyContact,
        officeAddress: userData.officeAddress,
        siteAddress: userData.siteAddress,
        remarks: userData.remarks,
        selectedFile: userData.document ? userData.document : "",
        approveStatus: userData.approveStatus,
        signature: userData.signature,
        dob: userData.dob,
      });
    }
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  async getDepartmentList() {
    let response = await DepartmentService.getDepartment();
    if (response && response.status) {
      this.setState({
        departmentArr: response.data.departments,
      });
    }
  }

  async getCompanyList() {
    let response = await optionMasterService.optionMasterByType("company", 0);

    if (response && response.status) {
      if (response.data && response.data.option_master) {
        this.setState({
          companyArr: response.data.option_master,
        });
      }
    } else {
      this.setState({
        companyArr: [],
      });
    }
  }
  async getRolesList() {
    let response = await RoleService.RoleList();

    if (response && response.status) {
      if (response.data && response.data.roles) {
        this.setState({
          roleArr: response.data.roles,
        });
      }
    } else {
      this.setState({
        roleArr: [],
      });
    }
  }
  async onSubmit(e) {
    e.preventDefault();

    let signatureId = null;
    let document_id = "";
    let formData = "";
    if (this.state.src) {
      formData = new FormData();

      let blob = await fetch(this.state.src).then((r) => r.blob());
      formData.append("file", blob);

      let fileUploadResponse = await CommmonService.uploadDocument(formData);
      if (fileUploadResponse?.status && fileUploadResponse.data) {
        document_id = fileUploadResponse.data.id;
      }
    }
    if (this.state.signatureSrc) {
      formData = new FormData();

      let blob = await fetch(this.state.signatureSrc).then((r) => r.blob());
      formData.append("file", blob);

      let fileUploadResponse = await CommmonService.uploadDocument(formData);
      if (fileUploadResponse?.status && fileUploadResponse.data) {
        signatureId = fileUploadResponse.data.id;
      }
    }

    var obj = {
      documentId: this.state.selectedFile?.id || null,
      displayName: this.state.displayName || null,
      employeeId: this.state.employeeId || null,
      functionName: this.state.functionName || null,
      siteName: this.state.siteName || null,
      supervisorName: this.state.supervisorName || null,
      joiningDate: this.state.joiningDate || null,
      landlineNumber: this.state.landlineNumber || null,
      emergencyContact: this.state.emergencyContact || null,
      officeAddress: this.state.officeAddress || null,
      siteAddress: this.state.siteAddress || null,
      remarks: this.state.remarks || null,
      dob: this.state.dob,
    };

    if (signatureId) obj.signatureId = signatureId;

    if (document_id) {
      obj.documentId = document_id;
    }

    let data = await UserService.editLoggedUser(obj);

    if (data && data.status) {
      toastr.success("User Updated Successfully");

      this.props.history.push("/profile/view");
    } else {
      toastr.warning(data?.message || "Something went wrong!");
    }
  }

  onChangeDate(inputDate) {
    var date = new Date(inputDate),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    var finaldate = [date.getFullYear(), mnth, day].join("-");

    this.setState({
      joiningDate: finaldate,
    });
  }

  handleFileSelect = (event) => {
    let file = event.target.files[0];
    if (file) {
      let src = URL.createObjectURL(file);
      this.setState({
        src,
        showImage: true,
        cropImage: true,
      });
    } else {
      this.setState({
        src: "",
        showImage: false,
        cropImage: false,
      });
    }
  };

  handleSignatureSelect = (event) => {
    const file = event.target.files[0];

    if (file) {
      const src = URL.createObjectURL(file);

      this.setState({
        signatureSrc: src,
        showSignatureImage: true,
        cropSignatureImage: true,
      });
    } else {
      this.setState({
        signatureSrc: "",
        showSignatureImage: false,
        cropSignatureImage: false,
      });
    }
  };

  handleCrop = async () => {
    let { crop, img } = this.state;
    if (!img) return;
    if (crop.height && crop.width) {
      const croppedImage = await this.getCroppedImg(img, crop, "test");

      this.setState({
        src: URL.createObjectURL(croppedImage),
        cropImage: false,
        showImage: false,
      });
    }
  };

  handleSignatureCrop = async () => {
    let { signatureCrop, signatureImg } = this.state;
    if (!signatureImg) return;
    if (signatureCrop.height && signatureCrop.width) {
      const croppedImage = await this.getCroppedImg(
        signatureImg,
        signatureCrop,
        "testSignature"
      );
      this.setState({
        signatureSrc: URL.createObjectURL(croppedImage),
        cropSignatureImage: false,
        showSignatureImage: false,
      });
    }
  };

  getCroppedImg = (image, crop, fileName) => {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );
    // As Base64 string
    // const base64Image = canvas.toDataURL('image/jpeg');
    // As a blob
    return new Promise((resolve) => {
      canvas.toBlob(
        (blob) => {
          blob.name = fileName;
          resolve(blob);
        },
        "image/jpeg",
        1
      );
    });
  };

  disableFutureDt = (current) => {
    const today = moment();
    return current.isBefore(today);
  };
  render() {
    const {
      firstName,
      lastName,
      email,
      roleId,
      classification,
      comapnyId,
      departmentId,
      displayName,
      employeeId,
      functionName,
      siteName,
      supervisorName,
      joiningDate,
      landlineNumber,
      emergencyContact,
      officeAddress,
      siteAddress,
      remarks,
      contactNumber,
      roleArr,
      departmentArr,
      selectedFile,
      companyArr,
      dob,
    } = this.state;

    let { isLoading, src, crop, cropImage } = this.state;

    return (
      <div>
        <Loader loading={isLoading}></Loader>
        <MainBreadcrumb
          routeSegments={[{ name: "Edit Profile", path: "#" }]}
          breadCrumbsText="Profile_icon_edit_profile"
        />
        <div className="row d-flex justify-content-center">
          <div className="col-md-10">
            <div className="card mt-4 mb-3" style={{ overflow: "visible" }}>
              <div className="card-body">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top"> </Tooltip>}
                >
                  <Link to="/profile/view" className="editUserProfile">
                    <FiEye color="#00b5ef" size="22" />
                  </Link>
                </OverlayTrigger>
                <form onSubmit={this.onSubmit} className="p-3 pb-0">
                  <div className="row align-items-center pb-4">
                    <div className="col-md-3 text-center">
                      {/* <div className="profile-imgbx"> */}
                      {/* {selectedFile && selectedFile.document_name ?
                                                    <img
                                                        className="img-thumbnail"
                                                        src={URL_CONFIG.IMG_URL + selectedFile.document_name}
                                                    />
                                                    :
                                                    <img src="/assets/images/user-default.png" />
                                                } */}
                      <div className="d-flex align-items-center">
                        {this.state.showImage ? (
                          <div className="logoCrop mb-2 mt-2">
                            <ReactCrop
                              src={src}
                              crop={crop}
                              circularCrop={false}
                              onImageLoaded={(image) => this.setState({ img: image })}
                              onChange={(newCrop) => {
                                this.setState({ crop: newCrop });
                              }}
                            />
                          </div>
                        ) : (
                          <div className="mr-3">
                            <div className="profile-imgbx">
                              {src ? (
                                <img
                                  className="img-thumbnail companyLogo"
                                  src={src}
                                  alt="company-logo"
                                />
                              ) : (
                                <React.Fragment>
                                  {selectedFile &&
                                    Object.keys(selectedFile).length > 0 && (
                                      <img
                                        className="img-thumbnail companyLogo"
                                        src={
                                          URL_CONFIG.IMG_URL + selectedFile.document_name
                                        }
                                        alt="company-logo"
                                      />
                                    )}
                                </React.Fragment>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="uploadFileBtn">
                        <label htmlFor="upload-single-file">
                          <FiCamera size="18" color="#00b5ef" />
                        </label>
                        <input
                          className="uploadFile"
                          onChange={(e) => this.handleFileSelect(e)}
                          id="upload-single-file"
                          type="file"
                          accept="image/*"
                        />
                      </div>

                      {/* </div> */}
                      {this.state.showImage && cropImage ? (
                        <Button onClick={this.handleCrop} className="btn-rounded">
                          Crop Image
                        </Button>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="col-md-9 userInfoDetails">
                      <h2>{firstName ? firstName : "" + lastName ? lastName : ""}</h2>
                      <p className="textLight">
                        <span>E-mail: </span>
                        {email}
                      </p>
                      <p className="textLight">
                        <span>Phone: </span>
                        {contactNumber}
                      </p>
                    </div>
                  </div>
                  <div className="userInfo_otherDetails">
                    <div className="row">
                      <div className="col-md-4 form-group mb-3">
                        <label>First Name</label>
                        <input
                          name="firstName"
                          type="text"
                          placeholder="Enter First Name"
                          className="form-control"
                          value={firstName}
                          onChange={this.onChange}
                          readOnly
                        />
                      </div>
                      <div className="col-md-4 form-group mb-3">
                        <label>Last Name</label>
                        <input
                          name="lastName"
                          type="text"
                          placeholder="Enter Last Name"
                          className="form-control"
                          value={lastName}
                          onChange={this.onChange}
                          readOnly
                        />
                      </div>
                      <div className="col-md-4 form-group mb-3">
                        <label>Email</label>
                        <input
                          name="email"
                          type="text"
                          placeholder="Enter Email Id"
                          className="form-control"
                          value={email}
                          onChange={this.onChange}
                          readOnly
                        />
                      </div>
                      <div className="col-md-4 form-group mb-3">
                        <label>Mobile</label>
                        <input
                          name="contactNumber"
                          type="text"
                          placeholder="Enter Mobile Number"
                          className="form-control"
                          value={contactNumber}
                          onChange={this.onChange}
                          readOnly
                        />
                      </div>

                      <div className="col-md-4 form-group mb-3">
                        <label>User Type</label>
                        {/* <select name="classification" className="form-control" value={classification} onChange={this.onChange} disabled>
                                                    <option value="">Select</option>
                                                    <option value={"Internal"}>Internal</option>
                                                    <option value={"External"}>External</option>
                                                </select> */}

                        <SimpleSelect
                          name="classification"
                          value={classification}
                          onChange={this.onChange}
                          id="id"
                          label="name"
                          options={[
                            { id: "Internal", name: "Internal" },
                            { id: "External", name: "External" },
                          ]}
                          init="Select"
                          disabled
                        ></SimpleSelect>
                      </div>
                      <div className="col-md-4 form-group mb-3">
                        <label>Access Type</label>
                        {/* <select name="roleId" className="form-control" value={roleId} onChange={this.onChange} disabled>
                                                    <option value="">Select</option>
                                                    {roleArr &&
                                                        roleArr.length > 0 &&
                                                        roleArr.map((data, index) => {
                                                            return (
                                                                <option key={index} value={data.id}>
                                                                    {data.title}
                                                                </option>
                                                            );
                                                        })}
                                                </select> */}

                        <SimpleSelect
                          name="roleId"
                          value={roleId}
                          onChange={this.onChange}
                          id="id"
                          label="title"
                          options={roleArr}
                          init="Select"
                          disabled
                        ></SimpleSelect>
                      </div>
                      <div className="col-md-4 form-group mb-3">
                        <label>Organisation Name</label>
                        {/* <select name="comapnyId" className="form-control" value={comapnyId} onChange={this.onChange} disabled>
                                                    <option value="">Select</option>
                                                    {companyArr &&
                                                        companyArr.length > 0 &&
                                                        companyArr.map((data, index) => {
                                                            return (
                                                                <option key={index} value={data.metaValue}>
                                                                    {data.metaValue}
                                                                </option>
                                                            );
                                                        })}
                                                </select> */}

                        <SimpleSelect
                          name="comapnyId"
                          value={comapnyId}
                          onChange={this.onChange}
                          id="metaValue"
                          label="metaValue"
                          options={companyArr}
                          init="Select"
                          disabled
                        ></SimpleSelect>
                      </div>
                      <div className="col-md-4 form-group mb-3">
                        <label>Display Name</label>
                        <input
                          name="displayName"
                          type="text"
                          placeholder="Enter Display Name"
                          className="form-control"
                          value={displayName}
                          onChange={this.onChange}
                        />
                      </div>
                      <div className="col-md-4 form-group mb-3">
                        <label>Employee Id</label>
                        <input
                          name="employeeId"
                          type="text"
                          placeholder="Enter Employee ID"
                          className="form-control"
                          value={employeeId}
                          onChange={this.onChange}
                        />
                      </div>
                      <div className="col-md-4 form-group mb-3">
                        <label>Department Name</label>
                        {/* <select
                                                    name="departmentId"
                                                    className="form-control"
                                                    value={departmentId}
                                                    onChange={this.onChange}
                                                    disabled={this.state.approveStatus === 1 ? true : false}
                                                >
                                                    <option value="">Select</option>
                                                    {departmentArr &&
                                                        departmentArr.length > 0 &&
                                                        departmentArr.map((data, index) => {
                                                            return (
                                                                <option key={index} value={data.id}>
                                                                    {data.name}
                                                                </option>
                                                            );
                                                        })}
                                                </select> */}

                        <SimpleSelect
                          name="departmentId"
                          value={departmentId}
                          onChange={this.onChange}
                          id="id"
                          label="name"
                          options={departmentArr}
                          init="Select"
                          disabled={this.state.approveStatus === 1 ? true : false}
                        ></SimpleSelect>
                      </div>
                      <div className="col-md-4 form-group mb-3">
                        <label>Function Name</label>
                        <input
                          name="functionName"
                          type="text"
                          placeholder="Enter Function Name"
                          className="form-control"
                          value={functionName}
                          onChange={this.onChange}
                        />
                      </div>

                      <div className="col-md-4 form-group mb-3">
                        <label>Plant/Site Name</label>
                        <input
                          name="siteName"
                          type="text"
                          placeholder="Enter Plant/Site Name"
                          className="form-control"
                          value={siteName}
                          onChange={this.onChange}
                        />
                      </div>
                      <div className="col-md-4 form-group mb-3">
                        <label>Supervisor Name</label>
                        <input
                          name="supervisorName"
                          type="text"
                          placeholder="Enter Supervisor Name"
                          className="form-control"
                          value={supervisorName}
                          onChange={this.onChange}
                        />
                      </div>
                      <div className="col-md-4 form-group mb-3">
                        <div className="mb-3">
                          <label>Date of Joining</label>
                          <DateTime
                            timeFormat={false}
                            placeholder="Status Date"
                            value={joiningDate}
                            dateFormat="YYYY-MM-DD"
                            formatDate={formatDate}
                            parseDate={parseDate}
                            onChange={(day) => this.onChangeDate(day)}
                            isValidDate={this.disableFutureDt}
                            inputProps={{ placeholder: "Select Date" }}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 form-group mb-3">
                        <label>Landline Number</label>
                        <input
                          name="landlineNumber"
                          type="text"
                          placeholder="Enter Landline Number"
                          className="form-control"
                          value={landlineNumber}
                          onChange={this.onChange}
                        />
                      </div>
                      <div className="col-md-4 form-group mb-3">
                        <label>Emergency Contact</label>
                        <input
                          name="emergencyContact"
                          type="text"
                          placeholder="Emergency Contact Number"
                          className="form-control"
                          value={emergencyContact}
                          onChange={this.onChange}
                        />
                      </div>
                      <div className="col-md-4 form-group mb-3">
                        <label>Office Address</label>
                        <textarea
                          name="officeAddress"
                          type="text"
                          placeholder="Office Address"
                          className="form-control"
                          value={officeAddress}
                          onChange={this.onChange}
                        />
                      </div>
                      <div className="col-md-4 form-group mb-3">
                        <label>Site Address</label>
                        <textarea
                          name="siteAddress"
                          type="text"
                          placeholder="Site Address"
                          className="form-control"
                          value={siteAddress}
                          onChange={this.onChange}
                        />
                      </div>
                      <div className="col-md-4 form-group mb-3">
                        <label>Remarks</label>
                        <input
                          name="remarks"
                          type="text"
                          placeholder="Remarks"
                          className="form-control"
                          value={remarks}
                          onChange={this.onChange}
                        />
                      </div>
                      <div className="col-md-4 form-group mb-3">
                        <label>Date of Birth</label>
                        <DatePicker
                          isValidDate={(day) => day.isBefore(new Date())}
                          onChange={(moment) =>
                            typeof moment !== "string" &&
                            this.onChange({
                              target: { name: "dob", value: moment.format("YYYY-MM-DD") },
                            })
                          }
                          value={dob}
                          format={"YYYY-MM-DD"}
                        />
                      </div>
                      <div className="col-md-8 form-group mb-3">
                        <label>Signature</label>
                        <CropImageModal
                          src={this.state.signatureSrc}
                          crop={this.state.signatureCrop}
                          image={this.state.signature}
                          onChangeInput={(event) => this.handleSignatureSelect(event)}
                          onImageLoaded={(image) =>
                            this.setState({ signatureImg: image })
                          }
                          onCrop={() => this.handleSignatureCrop()}
                          onChangeCrop={(newCrop) => {
                            this.setState({ signatureCrop: newCrop });
                          }}
                        />
                      </div>
                    </div>
                    <div className="text-center">
                      <Button
                        type="submit"
                        variant="primary"
                        className="m-1 text-capitalize"
                      >
                        Update Profile
                      </Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UserProfile;
